<template>
  <div>
    <v-icon class="mdi mdi-magnify search-icon"/>
    <input :id="id" :placeholder="placeholder" v-model="searchQuery" @input="handleSearch" class="search-input">
    <!-- <TextButton @click="handleSearch" buttonText="검색" class="ml-2" Black/> -->
  </div>
</template>

<script>
import TextButton from '@/components/ui/button/TextButton.vue';

import { mapActions } from 'vuex';

export default {
  components: {
    TextButton,
  },
  props: {
    id: String,
    placeholder: {
      type: String,
      default() {
            return this.$store.getters.t('동영상 제목 또는 태그로 동영상 찾기');
      }
    }
  },
  computed: {
    searchQuery: {
      get() {
        return this.$store.state.search.searchQuery;
      },
      set(value) {
        this.updateSearchQuery(value);
      }
    }
  },
  methods: {
    ...mapActions('search', ['updateSearchQuery']),
    handleSearch() {
      this.updateSearchQuery(this.searchQuery);
    },

  },
};
</script>

<style scoped>
.search-input {
  width: 70%;
  height: 36px;
  padding: 8px;
  margin-bottom: 12px;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-sizing: border-box;
  font-size: 14px;
  background: #fff;
  padding-left: 36px;
}

.search-icon {
    position: absolute;
    margin-left: 10px;
    margin-top: 6px;
    color: #aaa;
}

input:focus {
  outline: none;
  border: 1px solid #999;
}
@media only screen and (max-width: 600px) {
  .search-input {
    width: 80%;
  }
}
</style>
